module.exports = __webpack_public_path__ + "img/login.e0eed554.jpg";